import { render, staticRenderFns } from "./DateIOSPicker.vue?vue&type=template&id=40e83064&scoped=true&"
import script from "./DateIOSPicker.vue?vue&type=script&lang=js&"
export * from "./DateIOSPicker.vue?vue&type=script&lang=js&"
import style0 from "./DateIOSPicker.vue?vue&type=style&index=0&id=40e83064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e83064",
  null
  
)

export default component.exports